<template>
    <div class="layout-right"ref="layout-right">
        <div class="layout-right-top">
            <right-top bread="系统设置-提成设置"></right-top>
        </div>
        <div class="layout-right-body">
            <el-tabs v-model="activeName">
                <el-tab-pane label="项目提成设置" name="ProductOption">
                    <staff-reward-table-list :pro_type="type.product" />
                </el-tab-pane>
                <el-tab-pane label="卡项提成设置" name="CardOption">
                    <staff-reward-table-list :pro_type="type.card" />
                </el-tab-pane>
                <el-tab-pane label="商品提成设置" name="GoodsOption">
                    <staff-reward-table-list :pro_type="type.goods" />
                </el-tab-pane>
                <el-tab-pane label="会员提成设置" name="VipOption">
                    <staff-reward-table-list :pro_type="type.vip" />
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import RightTop from "@/model/RightTop";
    import obj from "@/js/obj";
    import StaffRewardTableList from "@/model/Option/StaffRewardTableList";
    export default {
        name: "StaffRewardList",
        components: {StaffRewardTableList, RightTop},
        props: {
            proType: {
                type: [String, Number],
                default: ""
            }
        },
        data: () => ({
            activeName: "ProductOption",
            type: {
                product: 1,
                goods: 2,
                vip: 4,
                card: 5
            }
        }),
        mounted: function () {
            this.$store.commit("setMenuId", "7-2");
        },
        methods: {

        },
    }
</script>

<style scoped>
    .layout-right-body{
        margin: 16px;
        background-color: #FFFFFF;
    }

</style>

